var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InnerScroll',{attrs:{"loading":_vm.pageDataLoading,"transparent":true}},[_c('Faq',{attrs:{"items":_vm.faq}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }